import { render, staticRenderFns } from "./BowFeatureGroup.vue?vue&type=template&id=aa743150&"
import script from "./BowFeatureGroup.vue?vue&type=script&lang=js&"
export * from "./BowFeatureGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowFeature: require('/workspace/components/molecules/BowFeature/BowFeature.vue').default})
